"use strict";
exports.__esModule = true;
exports.GreenhouseWebhookActionEnum = void 0;
var GreenhouseWebhookActionEnum;
(function (GreenhouseWebhookActionEnum) {
    GreenhouseWebhookActionEnum["DeleteApplication"] = "delete_application";
    GreenhouseWebhookActionEnum["ApplicationUpdated"] = "application_updated";
    GreenhouseWebhookActionEnum["NewCandidateApplication"] = "new_candidate_application";
    GreenhouseWebhookActionEnum["RejectCandidate"] = "reject_candidate";
    GreenhouseWebhookActionEnum["UnrejectCandidate"] = "unreject_candidate";
    GreenhouseWebhookActionEnum["UpdateCandidate"] = "update_candidate";
    GreenhouseWebhookActionEnum["DeleteCandidate"] = "delete_candidate";
    GreenhouseWebhookActionEnum["MergeCandidate"] = "merge_candidate";
    GreenhouseWebhookActionEnum["HireCandidate"] = "hire_candidate";
    GreenhouseWebhookActionEnum["CandidateStageChange"] = "candidate_stage_change";
    GreenhouseWebhookActionEnum["UnhireCandidate"] = "unhire_candidate";
    GreenhouseWebhookActionEnum["JobCreated"] = "job_created";
    GreenhouseWebhookActionEnum["JobDeleted"] = "job_deleted";
    GreenhouseWebhookActionEnum["JobUpdated"] = "job_updated";
    GreenhouseWebhookActionEnum["JobApproved"] = "job_approved";
    GreenhouseWebhookActionEnum["JobPostCreated"] = "job_post_created";
    GreenhouseWebhookActionEnum["JobPostUpdated"] = "job_post_updated";
    GreenhouseWebhookActionEnum["JobPostDeleted"] = "job_post_deleted";
    GreenhouseWebhookActionEnum["JobInterviewStageDeleted"] = "job_interview_stage_deleted";
    GreenhouseWebhookActionEnum["InterviewDeleted"] = "interview_deleted";
    GreenhouseWebhookActionEnum["ScorecardDeleted"] = "scorecard_deleted";
    GreenhouseWebhookActionEnum["NewProspectApplication"] = "new_prospect_application";
    GreenhouseWebhookActionEnum["DepartmentDeleted"] = "department_deleted";
    GreenhouseWebhookActionEnum["OfficeDeleted"] = "office_deleted";
    GreenhouseWebhookActionEnum["OfferCreated"] = "offer_created";
    GreenhouseWebhookActionEnum["OfferUpdated"] = "offer_updated";
    GreenhouseWebhookActionEnum["OfferDeleted"] = "offer_deleted";
})(GreenhouseWebhookActionEnum = exports.GreenhouseWebhookActionEnum || (exports.GreenhouseWebhookActionEnum = {}));
//# sourceMappingURL=webhook-enum.js.map